import { useTranslation } from 'react-i18next';

import { Button } from '@/components/common/Button';
import { Sheet } from '@/components/common/Sheet';

/**
 * «Abbandonare la partita?» (decisione di tma-orc 17/10 11:04Z su PER-LUCA 1 del report di fase 2: «Abbandona» NON abbandona al tocco, apre questa conferma): due tasti,
 * «Annulla» (il primario: si resta) e «Abbandona». Solo con «Abbandona» parte `resign`, e una volta sola (lo garantisce la rotta). Coerente col burraco, dove «Abbandona la partita» ha la sua conferma.
 * In piedi e un `Sheet` (si chiude anche col velo e col tasto indietro di Telegram: in tutti i casi si resta); nel palco orizzontale e un riquadro DENTRO il palco
 * (`palco`), perche un foglio fuori dal palco non girerebbe con lui. ⛔ Solo presentazione: non sa cosa fa `resign`.
 */
export interface CpConfermaAbbandonoProps {
  open: boolean;
  onAnnulla: () => void;
  onAbbandona: () => void;
  palco?: boolean;
}

function Contenuto({ onAnnulla, onAbbandona }: Pick<CpConfermaAbbandonoProps, 'onAnnulla' | 'onAbbandona'>) {
  const { t } = useTranslation('chinesepoker');
  return (
    <div data-conferma-abbandono className="flex flex-col gap-4 px-6 pb-3 pt-4 text-center">
      <h2 className="text-lg font-bold text-fg">{t('abbandono.titolo')}</h2>
      <p className="text-sm text-fg-muted">{t('abbandono.corpo')}</p>
      <div className="flex flex-col gap-2 pt-1">
        <Button fullWidth data-azione="abbandono-annulla" onClick={onAnnulla}>
          {t('abbandono.annulla')}
        </Button>
        <Button variant="neutro" fullWidth data-azione="abbandono-conferma" onClick={onAbbandona}>
          {t('match.resign')}
        </Button>
      </div>
    </div>
  );
}

export function CpConfermaAbbandono({ open, onAnnulla, onAbbandona, palco = false }: CpConfermaAbbandonoProps) {
  const { t } = useTranslation('chinesepoker');
  if (palco) {
    return open ? (
      <div data-conferma-abbandono-palco role="dialog" aria-label={t('abbandono.titolo')} className="absolute inset-0 z-30 flex items-center justify-center bg-black/55">
        <div className="tav-panno w-[360px] rounded-2xl">
          <Contenuto onAnnulla={onAnnulla} onAbbandona={onAbbandona} />
        </div>
      </div>
    ) : null;
  }
  return (
    <Sheet open={open} onClose={onAnnulla} label={t('abbandono.titolo')}>
      <Contenuto onAnnulla={onAnnulla} onAbbandona={onAbbandona} />
    </Sheet>
  );
}
